import ApiService from "./api.service";

class NewsService extends ApiService {
    getNews(all) {
        return this.get(`api/meeting/news/${all}`);
    }
}

export default new NewsService();
